import { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ConfirmationModal from "../modals/ConfirmationModal";
import useCreate from "../../../hooks/useCreate";
import toast from "react-hot-toast";

const OrdersActionDropdown = ({ orderId, orderState }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Confirmation modal state
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Function to handle marking order as paid
  const { setDataToServer } = useCreate({
    url: "mark_as_paid",
    refreshUrl: "ordersList",
    onSuccess: (data) => {
      setIsModalOpen(false);
      // Optionally, you can refresh the order list or show a success message
      toast.success(
        orderState === "1"
          ? "Order marked as paid successfully!"
          : "Order marked as unpaid successfully!"
      );
    },
    onError: (error) => {
      // Optionally, you can show an error message
      toast.error(
        orderState === "1"
          ? "Failed to mark order as paid"
          : "Failed to mark order as unpaid"
      );
    },
  });

  const toggleOrderStatus = () => {
    setDataToServer.mutate({
      id: orderId,
      paid: orderState === "1" ? true : false, // If 1, then mark as paid, else if 2 mark as unpaid
    });
  };

  const openMarkAsPaidModal = () => {
    setIsModalOpen(true);
    handleClose();
  };

  return (
    <>
      <ConfirmationModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        title={`Mark as ${orderState === "1" ? "Paid" : "Unpaid"}`}
        message={`Are you sure you want to mark this order as ${
          orderState === "1" ? "paid" : "unpaid"
        }?`}
        confirmLabel={`Yes, Mark as ${orderState === "1" ? "Paid" : "Unpaid"}`}
        onConfirm={toggleOrderStatus}
        cancelLabel="No, Cancel"
        onCancel={() => setIsModalOpen(false)}
        isLoading={setDataToServer.isLoading}
        loadingMessage="Processing..."
      />
      <div className="grid place-items-center">
        <button className="relative" onClick={handleClick}>
          <MoreVertIcon className="cursor-pointer" />
        </button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <MenuItem onClick={openMarkAsPaidModal}>Mark as {orderState === "1" ? "Paid" : "Unpaid"}</MenuItem>
        </Menu>
      </div>
    </>
  );
};

export default OrdersActionDropdown;
